var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleartrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 445.79 124.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f05325;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.47,46.39c-6.28,0-9.43,2.78-9.43,9.07v23.69h7.43v-23.33c0-2.07,.93-3.07,3.07-3.07h6.5v-6.36h-7.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.89,31.6c-2.43,0-4.43,2-4.43,4.5s2,4.43,4.43,4.43,4.5-2,4.5-4.43-2-4.5-4.5-4.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 329.25,
    y: 46.24,
    width: 7.36,
    height: 32.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.29,72.88c-2.14,0-3.07-.57-3.07-2.71V31.65h-7.43v38.52c0,6.5,3.64,9.07,9.35,9.07h3.93v-6.36h-2.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.12,46.27c-6.28,0-9.43,2.78-9.43,9.07v23.78h7.43v-23.42c0-2.07,.93-3.07,3.07-3.07h6.5v-6.36h-7.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.33,46.3v-8.21h-7.43v31.99c0,6.21,3.21,9.07,9.43,9.07h5.57v-6.36h-4.5c-2,0-3.07-.71-3.07-2.71v-17.42h7.57v-6.36h-7.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.82,46.5v46.87h7.43v-17.07c2.66,1.84,5.88,2.93,9.35,2.93,9.07,0,16.42-7.35,16.42-16.42s-7.35-16.42-16.42-16.42c-3.48,0-6.7,1.09-9.35,2.93v-2.82h-7.43Zm7.43,16.31c0-5.17,4.19-9.35,9.35-9.35s9.35,4.19,9.35,9.35-4.19,9.35-9.35,9.35-9.35-4.19-9.35-9.35Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.92,62.1c0-10-6.71-15.71-15.5-15.71-9.85,0-15.92,6.86-15.92,16.35s6.71,16.5,16.07,16.5c8.28,0,12.64-3.71,14.71-9.85h-8c-1.21,2.36-3.5,3.43-6.86,3.43-4.43,0-8.07-2.78-8.35-7.78h23.71c.14-1.57,.14-2.29,.14-2.93Zm-23.78-2.36c.64-4.36,3.71-7,8.5-7s7.43,2.5,7.85,7h-16.35Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.8,67.95c-1.21,3.43-3.5,4.86-6.93,4.86-5.64,0-8.07-4.43-8.07-10.07s2.78-10,8.21-10c3.43,0,5.71,1.79,6.78,4.86h7.93c-1.86-7.5-7.43-11.21-14.85-11.21-10,0-15.64,7.14-15.64,16.35,0,10,6.64,16.5,15.64,16.5s13.35-5.07,14.85-11.28h-7.93Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.61,47.74c-12.5,9.14-23.28,21.14-32.92,31.21-.71,.71-1.64,1.21-2.64,1.21-1.21,0-2.14-.71-3-2-2.5-3.71-6.28-12.71-8-16.64-1.36-3.21-.64-5.86,2.57-7.21,3.21-1.29,6.78-1.5,7.64,2.14,0,0,1.64,6.36,2.14,8.21,9.93-9.21,22.14-18.99,32.49-24.99-2.57-4.86-7.64-8.14-13.42-8.14h-24.49c-8.43,0-15.21,6.78-15.21,15.14v24.56c0,8.35,6.78,15.14,15.21,15.14h24.49c8.35,0,15.14-6.78,15.14-15.14v-23.49Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.06,46.5v2.82c-2.66-1.84-5.88-2.93-9.35-2.93-9.07,0-16.42,7.35-16.42,16.42s7.35,16.42,16.42,16.42c3.48,0,6.7-1.09,9.35-2.93v2.79h7.43V46.5h-7.43Zm-9.35,25.66c-5.17,0-9.35-4.19-9.35-9.35s4.19-9.35,9.35-9.35,9.35,4.19,9.35,9.35-4.19,9.35-9.35,9.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleartrip);
export default __webpack_public_path__ + "static/media/CLEARTRIP.99aa2fd5bcc2b7750c3eb83c79ce689b.svg";
export { ForwardRef as ReactComponent };